<template>
  <div class="radio">
    <div @click="methodSelectItem(selected)" class="fb fb-cross-center">
      <i
        class="iconfont font-48"
        :class="{
          'c-006AFE': selected,
          'c-171A1D-40': !selected && !disabled,
          'c-171A1D-12': disabled
        }"
        >{{ selected ? '&#xe66e;' : '&#xe66f;' }}</i
      >
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    methodSelectItem(isSelected) {
      if (this.disabled) {
        return false
      }
      this.selected = !this.selected
      this.$emit('radio', this.selected)
    }
  }
}
</script>
<style lang="scss" scoped></style>
